export const CURRENCIES = {
  SGD: {
    code: "SGD",
    symbol: "S$",
  },
  BRL: {
    code: "BRL",
    symbol: "R$",
  },
  MYR: {
    code: "MYR",
    symbol: "RM",
  },
  THB: {
    code: "THB",
    symbol: "฿",
  },
  PHP: {
    code: "PHP",
    symbol: "₱",
  },
  IDR: {
    code: "IDR",
    symbol: "Rp",
  },
  COP: {
    code: "COP",
    symbol: "$",
  },
  EUR: {
    code: "EUR",
    symbol: "€",
  },
  HKD: {
    code: "HKD",
    symbol: "HK$",
  },
  JPY: {
    code: "JPY",
    symbol: "¥",
  },
  USD: {
    code: "USD",
    symbol: "$",
  },
  HUF: {
    code: "HUF",
    symbol: "Ft",
  },
  TWD: {
    code: "TWD",
    symbol: "NT$",
  },
} as const

export type CountryCurrencies = string
